<template>
  <img v-if="src" :src="src" :alt="alt" />
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrImage',
  props: {
    value: { type: String, required: true },
    alt: { type: String, default: 'QR code' },
    size: { type: Number, default: 120 }
  },
  data() {
    return { src: '' }
  },
  watch: {
    value: { immediate: true, handler: 'generate' }
  },
  methods: {
    async generate() {
      if (!this.value) {
        this.src = ''
        return
      }
      this.src = await QRCode.toDataURL(this.value, { width: this.size, margin: 1 })
    }
  }
}
</script>
